<script>
import { mapState, mapGetters } from 'vuex'
import Practice from '@/components/Practice.vue'
import Validation from '@/plugins/validation'
const axios = require('axios')

export default {
  name: 'PracticeSelection',
  components: {
    Practice,
  },
  data() {
    return {
      filteredClinics: [],
      matchingZips: [],
      valid: false,
      ...Validation
    }
  },
  computed: {
    ...mapState(['selectedPractice']),
    ...mapGetters({
      practices: 'filteredPractices'
    }),
    zip: {
      get() {
        return this.$store.state.zip
      },
      set(val) {
        this.$store.dispatch('SET_ZIP', val)
      },
    }, 
    
  },
  methods: {

  },
  watch:{
    zip: function(z) {
      if(this.zip.length == 5) {
        this.$store.dispatch('GET_NEAREST_PRACTICES', z)
      }
      else {
        this.$store.dispatch('CLEAR_NEAREST_PRACTICES')
      }
    } 
  }
}
</script>

<template>
  <v-row>
    <v-col>
      <v-row align="center" justify="center">
        <v-col class="inset">
          <h2 class="mb-2">Welcome to Healthy Pet&nbsp;+</h2>
          Enter your zip code or click on a location from the list to select your practice.
          <v-form :lazy-validation="true">
            <v-container class="align-center text-center">
              <v-row align="center" justify="center">
                <v-col
                  md="6"
                  cols="12"
                >
                  <v-text-field
                    class="mx-4"
                    maxlength="5"
                    v-model="zip"
                    :rules="zipRules"
                    label="Zip Code"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-col>
      </v-row>
      <v-row align="center" justify="center">
        <v-col md="6" cols="12">
          <Practice v-for="practice in practices" :key="practice.name" :practice="practice" />
          <div v-if="practices.length == 0">No practices found near {{ zip }}</div>
          <!-- <v-btn class="my-8" v-if="selectedPractice" @click="$store.dispatch('RESET_PRACTICE')">Reset</v-btn> -->
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<style lang="scss" scoped>
  h2 {
    color: $hpp-darkblue;
    font-weight: 400;
  }
</style>
